// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tip":"batch-entry-tipbox__tip___1jG0T","icon":"batch-entry-tipbox__icon___2hejj","icon-svg":"batch-entry-tipbox__icon-svg___LeSV4","iconSvg":"batch-entry-tipbox__icon-svg___LeSV4","text":"batch-entry-tipbox__text___1O5OH"};
    if(module.hot) {
      // 1759439447247
      var cssReload = require("../../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  